/* Coordinates Inbox/Forms with Horizon's native sticky-add-to-cart component. */
(() => {
  const page = document.querySelector('#MainContent');
  if (!page || document.body.hasAttribute('data-friends-widget-clearance')) return;
  document.body.setAttribute('data-friends-widget-clearance', '1');
  const marker = 'data-friends-widget-clearance-hidden';
  const mobile = window.matchMedia('(max-width: 749px)');
  const controls = 'main a, main button, main input, main select, main summary, main label, footer a, footer button, footer input, footer select, #checkout, shopify-accelerated-checkout-cart';
  let frame = 0, formsRoot, chatHost, purchaseInner;
  const chatRoots = new WeakSet();
  const chatOffset = '--shopify-chat-activator-offset';
  let offsetHost, savedOffset = '', savedPriority = '';
  const restoreChatOffset = () => {
    if (!offsetHost) return;
    if (savedOffset) offsetHost.style.setProperty(chatOffset, savedOffset, savedPriority);
    else offsetHost.style.removeProperty(chatOffset);
    offsetHost = undefined;
  };
  const watchChatRoot = root => {
    if (!root || chatRoots.has(root)) return;
    chatRoots.add(root);
    root.addEventListener('transitionend', schedule, true);
    root.addEventListener('animationend', schedule, true);
    observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-expanded'] });
  };
  // Measure the native position each time, so our own offset cannot accumulate
  // or alternate between two positions. Inbox replaces its launcher after use.
  const clearPurchaseControls = chat => {
    restoreChatOffset();
    const shell = chat?.shadowRoot;
    const runtime = shell?.querySelector('shopify-agent-runtime')?.shadowRoot;
    watchChatRoot(shell);
    watchChatRoot(runtime);
    const launcher = runtime?.querySelector('button[aria-label="Chat"]') || shell?.querySelector('button[aria-label="Chat"]');
    if (!launcher || chat.hasAttribute('open') || chat.hasAttribute(marker) || launcher.getAttribute('aria-expanded') === 'true') return;
    const original = launcher.getBoundingClientRect();
    if (!original.width || !original.height) return;
    const gap = 12;
    const overlaps = (a, b) => b.width > 0 && b.height > 0 && a.right > b.left && a.left < b.right && a.bottom > b.top - gap && a.top < b.bottom + gap;
    const purchaseControls = document.querySelectorAll('.product-details .product-form-buttons, .product-details fieldset, .product-details .friends-size-guide');
    if (!Array.from(purchaseControls).some(control => overlaps(original, control.getBoundingClientRect()))) return;
    // Treat Shop Pay's whole host as protected; its button lives in a shadow root.
    const obstacles = [...purchaseControls, ...document.querySelectorAll(controls + ', .product-form-buttons')]
      .map(control => control.getBoundingClientRect())
      .filter(rect => rect.width > 0 && rect.height > 0 && original.right > rect.left && original.left < rect.right)
      .sort((a, b) => b.top - a.top);
    const candidate = { top: original.top, bottom: original.bottom, left: original.left, right: original.right };
    for (const obstacle of obstacles) {
      if (!overlaps(candidate, obstacle)) continue;
      candidate.bottom = obstacle.top - gap;
      candidate.top = candidate.bottom - original.height;
    }
    // In a short viewport, never move the launcher into the header or offscreen.
    // Keep a keyboard-focused launcher reachable; open conversations are untouched.
    const header = document.querySelector('#header-component')?.getBoundingClientRect();
    const limit = Math.max(window.visualViewport?.offsetTop || 0, header?.bottom || 0) + gap;
    if (candidate.top < limit) {
      if (!focused(chat)) setHidden(chat, true);
      return;
    }
    const delta = Math.ceil(original.bottom - candidate.bottom);
    if (delta <= 0) return;
    const base = getComputedStyle(chat).getPropertyValue(chatOffset).trim() || '20px';
    savedOffset = chat.style.getPropertyValue(chatOffset);
    savedPriority = chat.style.getPropertyPriority(chatOffset);
    offsetHost = chat;
    chat.style.setProperty(chatOffset, 'calc(' + base + ' + ' + delta + 'px)');
  };
  const schedule = () => { if (!frame) frame = window.requestAnimationFrame(refresh); };
  const observe = (target, options) => new MutationObserver(schedule).observe(target, options);
  const focused = host => document.activeElement === host || host.contains(document.activeElement);
  const setHidden = (host, hidden) => {
    if (host && host.hasAttribute(marker) !== hidden) host.toggleAttribute(marker, hidden);
  };
  const controlsNeedRoom = () => {
    const viewport = window.visualViewport;
    const top = viewport?.offsetTop || 0;
    const bottom = top + (viewport?.height || window.innerHeight);
    return Array.from(document.querySelectorAll(controls)).some(control => {
      const rect = control.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.bottom > Math.max(top, bottom - 96) && rect.top < bottom;
    });
  };
  function refresh() {
    frame = 0;
    const chat = document.querySelector('shopify-chat');
    const forms = document.querySelector('shopify-forms-embed#app-embed-container-677785');
    if (chat && chat !== chatHost) {
      chatHost = chat;
      observe(chat, { attributes: true, attributeFilter: ['open'] });
    }
    if (forms?.shadowRoot && forms.shadowRoot !== formsRoot) {
      formsRoot = forms.shadowRoot;
      observe(formsRoot, { childList: true, subtree: true, attributes: true });
    }
    const overlayOpen = !!document.querySelector('dialog[open], theme-drawer[open], header-drawer details[open], .header__drawer details[open]');
    const hasDialog = forms?.shadowRoot?.querySelector('form, [role="dialog"], dialog');
    const teaser = forms?.shadowRoot?.querySelector('[data-current-step="tease"] button[data-testid="form-teaser"]');
    const purchase = document.querySelector('sticky-add-to-cart');
    const inner = purchase?.querySelector('[ref="stickyBar"]');
    if (inner && inner !== purchaseInner) {
      purchaseInner = inner;
      new ResizeObserver(schedule).observe(inner);
    }
    const editing = document.activeElement?.matches('textarea, [contenteditable="true"], input:not([type="radio"]):not([type="checkbox"]):not([type="button"]):not([type="submit"])');
    const suppressed = !!(overlayOpen || hasDialog || chat?.hasAttribute('open') || editing || (window.visualViewport?.scale || 1) > 1.02);
    purchase?.toggleAttribute('data-friends-purchase-suppressed', suppressed);
    const active = !!(inner && !suppressed && inner.dataset.stuck === 'true' && purchase.dataset.variantAvailable === 'true');
    document.body.toggleAttribute('data-friends-purchase-active', active);
    if (active) {
      const offset = inner.getBoundingClientRect().height + (parseFloat(getComputedStyle(inner).bottom) || 0);
      document.body.style.setProperty('--friends-purchase-height', `${offset}px`);
    }
    const needsRoom = mobile.matches && (overlayOpen || active || controlsNeedRoom());
    setHidden(chat, !!((overlayOpen || hasDialog) && chat && !chat.hasAttribute('open') && !focused(chat)));
    clearPurchaseControls(chat);
    setHidden(forms, !!(needsRoom && teaser && !hasDialog && !focused(forms)));
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('scroll', schedule, { passive: true });
  mobile.addEventListener('change', schedule);
  document.addEventListener('focusin', schedule);
  document.addEventListener('focusout', schedule);
  document.addEventListener('load', schedule, true);
  observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'hidden', 'class', 'data-stuck', 'data-variant-available'] });
  new ResizeObserver(schedule).observe(page);
  let discoveryAttempts = 0;
  const discoverApps = window.setInterval(() => {
    if (++discoveryAttempts > 30 || (chatHost?.isConnected && formsRoot?.host.isConnected)) {
      window.clearInterval(discoverApps);
      return;
    }
    schedule();
  }, 1000);
  refresh();
})();
